export default function exploreOurCollectionsController() {
  const section = document.querySelector('.explore-our-collections');

  if (!section) {
    return;
  }

  /* ---------- Buttons ---------- */
  const buttonsWrap = section.querySelector('.explore-our-collections__buttons');
  const buttonsSwiperElement = buttonsWrap.querySelector('.swiper');
  const buttons = [...buttonsWrap.querySelectorAll('.explore-our-collections__button')];

  /* ---------- Tabs ---------- */
  const tabs = [...section.querySelectorAll('.explore-our-collections__tab')];
  const handleToIndex = Object.fromEntries(tabs.map((t, i) => [t.dataset.handle, i]));
  const tabsSwipers = new Array(tabs.length).fill(null); // will hold Swiper instances
  let activeIndex = tabs.findIndex((t) => t.classList.contains('active'));

  /* ---------- CTA buttons ---------- */
  const ctaButtons = [...section.querySelectorAll('.explore-our-collections__cta')];
  const ctaTitles = ctaButtons.map((btn) => btn.querySelector('.collection-title'));

  const isVerticalLayout = section.classList.contains('explore-our-collections--vertical');
  const usePrefixAsButtonText = section.classList.contains('explore-our-collections--use-prefix-as-button-text');

  let breakpoints = {
    0: { slidesPerView: 1.5 },
    750: { slidesPerView: 2 },
    1260: { slidesPerView: 3 },
  };

  if (isVerticalLayout) {
    breakpoints = {
      0: { slidesPerView: 2 },
      990: { slidesPerView: 4 },
    };
  }

  const updateCTAButton = (text, href) => {
    if (usePrefixAsButtonText) {
      return;
    }

    ctaButtons.forEach((btn, i) => {
      ctaTitles[i].textContent = text;
      btn.href = href;
    });
  };

  /* ---------- Swiper helpers ---------- */
  const makeTabSwiper = (tab) => {
    const swiperEl = tab.querySelector('.swiper');
    const swiper = new Swiper(swiperEl, {
      init: false, // lazy
      direction: 'horizontal',
      spaceBetween: 16,
      watchSlidesProgress: true,
      navigation: {
        nextEl: tab.querySelector('.swiper-button-next'),
        prevEl: tab.querySelector('.swiper-button-prev'),
      },
      pagination: {
        el: tab.querySelector('.swiper-pagination'),
        type: 'progressbar',
      },
      breakpoints,
    });

    swiper.on('lock', () => swiperEl.classList.add('swiper--locked'));
    swiper.on('unlock', () => swiperEl.classList.remove('swiper--locked'));
    return swiper;
  };

  // initialise only the active tab swiper now

  whenInViewport(section, () => {
    tabsSwipers[activeIndex] = makeTabSwiper(tabs[activeIndex]);
    tabsSwipers[activeIndex].init();
  });

  /* ---------- Buttons Swiper ---------- */
  new Swiper(buttonsSwiperElement, {
    slidesPerView: 'auto',
    spaceBetween: 8,
    mousewheel: true,
    loop: false,
    watchSlidesProgress: true,
    pagination: {
      el: buttonsSwiperElement.querySelector('.swiper-pagination'),
      type: 'progressbar',
    },
  });

  /* ---------- Event delegation ---------- */
  buttonsWrap.addEventListener('click', (e) => {
    const btn = e.target.closest('.explore-our-collections__button');
    if (!btn) return;

    /* nothing to do if already active */
    const targetIdx = handleToIndex[btn.dataset.handle];
    if (targetIdx === activeIndex) return;

    /* switch active button */
    buttons[activeIndex].classList.remove('active');
    btn.classList.add('active');

    /* elements involved in the fade */
    const oldTab = tabs[activeIndex];
    const newTab = tabs[targetIdx];
    const newSwiper = tabsSwipers[targetIdx] ?? (tabsSwipers[targetIdx] = makeTabSwiper(newTab));

    /* fade-out old, fade-in new */
    oldTab.classList.add('fade-out');

    const onFadeEnd = () => {
      oldTab.removeEventListener('transitionend', onFadeEnd);

      // reset classes
      oldTab.classList.remove('active', 'fade-out');
      newTab.classList.add('active', 'fade-in');

      requestAnimationFrame(() => newTab.classList.remove('fade-in'));

      // lazy-init the Swiper only once
      if (!newSwiper.initialized) newSwiper.init();
      newSwiper.update();

      // CTA buttons
      updateCTAButton(btn.dataset.title, btn.dataset.href);

      activeIndex = targetIdx;
    };

    oldTab.addEventListener('transitionend', onFadeEnd, { once: true });
  });
}
